export default "__VITE_ASSET__77fe3685__"